import gql from 'graphql-tag';

export const GET_LIST_VODGUIDE = gql`
  query ($perPage: Int!, $page: Int!, $search: String) {
    vodguideList(first: $perPage, page: $page, title: $search) {
      data {
        id
        title
        created_at
        guide_xml
      }
      paginatorInfo {
        firstItem
        lastItem
        currentPage
        lastPage
        total
        perPage
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/vodguide/list.js